import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import PillarArticlePage from "@/pages/pillarArticle/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/usfans-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/guides/:slug",
    element: <PillarArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;